import { alpha, Chip, ChipProps, SxProps } from "@mui/material";

interface IChipCore extends ChipProps {
  colorCore: string;
  sxStyle?: SxProps;
}

export const ChipCore = ({ colorCore, sxStyle, ...props }: IChipCore) => {
  return (
    <Chip
      size={props.size || "small"}
      label={props.label || ""}
      sx={{
        color: colorCore,
        backgroundColor: colorCore ? alpha(colorCore, 0.1) : undefined,
        // border: colorCore ? `1px solid ${alpha(colorCore, 0.2)}` : undefined,
        ...sxStyle,
      }}
      {...props}
    />
  );
};